export default __webpack_public_path__ + "cd2d5a6c6312a167b854a5cab54f1bdd.png";